var render = function render(){var _vm=this,_c=_vm._self._c;return _c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"Menu","title":"Menu"}},[_c('hr'),(_vm.$route.name == 'dashboard' || _vm.$route.name == 'class-list')?_c('b-button',{staticClass:"logo-header",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.openJoinClassModal}},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" Gabung Kelas")]):_vm._e(),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: 'Dashboard',
        icon: 'fa fa-home text-custom-primary',
        routeName: 'dashboard',
        param: null,
      }}}),(_vm.user.type == 'murid' && _vm.user.isGraduation == '1')?_c('sidebar-item',{attrs:{"link":{
        name: 'Kelulusan',
        icon: 'fa fa-graduation-cap text-custom-primary',
        routeName: 'graduation',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Setting Background',
        icon: 'fa fa-images text-custom-primary',
        routeName: 'background-setting-list',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Setting Tahun Ajaran',
        icon: 'fa fa-calendar text-custom-primary',
        routeName: 'tahun-ajaran-list',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Upload Kelulusan',
        icon: 'fa fa-graduation-cap text-custom-primary',
        routeName: 'admin-graduation',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Monitoring User Modul',
        icon: 'fa fa-users text-custom-primary',
        routeName: 'user-modul-activity-list',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Users',
        icon: 'fa fa-users text-custom-primary',
        routeName: 'user-setting-list',
        param: null,
      }}}):_vm._e(),((_vm.$route.name == 'user-activity' || _vm.$route.name == 'user-setting-list' || _vm.$route.name == 'user-absence') && _vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Aktivitas User',
        icon: 'fa fa-user-md text-custom-primary',
        routeName: 'user-activity',
        param: { subjectId: _vm.currentSubjectId },
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Absensi Siswa',
        icon: 'fa fa-book text-custom-primary',
        routeName: 'user-absence',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Kunci Semester',
        icon: 'fa fa-lock text-custom-primary',
        routeName: 'lock-semester',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Hak Akses Rapor',
        icon: 'fa fa-user-secret text-custom-primary',
        routeName: 'permission-rapor',
        param: null,
      }}}):_vm._e(),(_vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Formulir Pendaftaran',
        icon: 'fa fa-file text-custom-primary',
        routeName: 'formulir-pendaftaran',
        param: null,
      }}}):_vm._e(),((_vm.$route.name == 'class-detail' || _vm.$route.name == 'download-nilai') && _vm.user.type == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: 'Download Nilai',
        icon: 'fa fa-user-md text-custom-primary',
        routeName: 'download-nilai',
        param: null,
      }}}):_vm._e(),(_vm.$route.name == 'subject-detail' || _vm.$route.name == 'study-instructions' || _vm.$route.name == 'student-progress')?_c('sidebar-item',{attrs:{"link":{
        name: 'Petunjuk Belajar',
        icon: 'fa fa-graduation-cap text-custom-primary',
        routeName: 'study-instructions',
        param: { subjectId: _vm.currentSubjectId },
      }}}):_vm._e(),(_vm.$route.name == 'subject-detail' || _vm.$route.name == 'study-instructions' || _vm.$route.name == 'student-progress')?_c('sidebar-item',{attrs:{"link":{
        name: 'Pelajaran',
        icon: 'fa fa-book text-custom-primary',
        routeName: 'subject-detail',
        param: { subjectId: _vm.currentSubjectId },
      }}}):_vm._e(),(
        _vm.$route.name == 'modul-detail' ||
        _vm.$route.name == 'modul-discuss' ||
        _vm.$route.name == 'task-list' ||
        _vm.$route.name == 'modul-appraisal' ||
        _vm.$route.name == 'modul-appraisal-question' ||
        _vm.$route.name == 'student-task-list' ||
        _vm.$route.name == 'appraisal-list' ||
        _vm.$route.name == 'student-appraisal-list'
      )?_c('sidebar-item',{attrs:{"link":{
        name: 'Materi',
        icon: 'fa fa-book text-custom-primary',
        routeName: 'modul-detail',
        param: { modulId: _vm.currentModulId },
      }}}):_vm._e(),(
        _vm.$route.name == 'modul-detail' ||
        _vm.$route.name == 'modul-discuss' ||
        _vm.$route.name == 'task-list' ||
        _vm.$route.name == 'modul-appraisal' ||
        _vm.$route.name == 'modul-appraisal-question' ||
        _vm.$route.name == 'student-task-list' ||
        _vm.$route.name == 'appraisal-list' ||
        _vm.$route.name == 'student-appraisal-list'
      )?_c('sidebar-item',{attrs:{"link":{
        name: 'Penugasan',
        icon: 'fa fa-file text-custom-primary',
        routeName: 'modul-task',
        param: { modulId: _vm.currentModulId },
      }}}):_vm._e(),(
        _vm.$route.name == 'modul-detail' ||
        _vm.$route.name == 'modul-discuss' ||
        _vm.$route.name == 'task-list' ||
        _vm.$route.name == 'modul-appraisal' ||
        _vm.$route.name == 'modul-appraisal-question' ||
        _vm.$route.name == 'student-task-list' ||
        _vm.$route.name == 'appraisal-list' ||
        _vm.$route.name == 'student-appraisal-list'
      )?_c('sidebar-item',{attrs:{"link":{
        name: 'Penilaian',
        icon: 'fa fa-suitcase text-custom-primary',
        routeName: 'modul-appraisal',
        param: { modulId: _vm.currentModulId },
      }}}):_vm._e(),(
        _vm.$route.name == 'modul-detail' ||
        _vm.$route.name == 'modul-discuss' ||
        _vm.$route.name == 'task-list' ||
        _vm.$route.name == 'modul-appraisal' ||
        _vm.$route.name == 'modul-appraisal-question' ||
        _vm.$route.name == 'student-task-list' ||
        _vm.$route.name == 'appraisal-list' ||
        _vm.$route.name == 'student-appraisal-list'
      )?_c('sidebar-item',{attrs:{"link":{
        name: 'Diskusi',
        icon: 'fa fa-comments text-custom-primary',
        routeName: 'modul-discuss',
        param: { modulId: _vm.currentModulId },
      }}}):_vm._e(),(_vm.user.type == 'admin' || (_vm.user.type == 'tutor' && _vm.user.raporPermission === '1'))?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('a',{staticClass:"icon-clicked external-link",attrs:{"href":_vm.baseRaporUrl + '/main-sign-in?ctkn=' + encodeURIComponent(_vm.token2),"target":"_blank"}},[_c('i',{staticClass:"fa fa-book-open color-icon",attrs:{"aria-hidden":"true"}}),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v("Rapor")])])]):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }